import React, { useRef } from "react";

import { SwiperSlide, Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Navigation, FreeMode } from "swiper";
import { nanoid } from "nanoid";

import { arrLeft, arrRight } from "../../svgs";
import ProductCard from "../productCard";
import BlogsCard from "../blogs/blogsCard";
import { MultySliderWrapper } from "./styled";

SwiperCore.use([Navigation, FreeMode]);

const MultySlider: React.FC<{
  slides: any;
  headline: string;
  blog?: boolean;
}> = ({ slides, headline, blog }) => {
  // swiper
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <MultySliderWrapper>
      <div className="header">
        <h4 className="title">{headline}</h4>

        <div className="actions">
          {/* custom btns */}
          <button className="btn" ref={prevRef}>
            {arrLeft()}
          </button>
          <button className="btn" ref={nextRef}>
            {arrRight()}
          </button>
        </div>
      </div>

      <Swiper
        className={`multy-slider ${blog ? "no-edge" : ""}`}
        speed={250}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.prevEl = prevRef.current;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line no-param-reassign
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        breakpoints={{
          300: {
            slidesPerView: blog ? 1.2 : 2,
            spaceBetween: 16,
            freeMode: true,
          },
          741: {
            slidesPerView: blog ? 3 : 4,
            spaceBetween: 20,
          },
          960: {
            slidesPerView: blog ? 4 : 6,
            spaceBetween: 32,
            freeMode: false,
          },
        }}
      >
        {slides.map((el, i) => {
          return (
            <SwiperSlide key={nanoid()}>
              {blog ? <BlogsCard el={el} /> : <ProductCard productData={el} />}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </MultySliderWrapper>
  );
};

export default MultySlider;
